import React from 'react';

export const PadlockOpenSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="15"
    height="20"
    viewBox="0 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 7.53487C12.5 7.53487 12.5 12.0304 12.5 6.03487C12.5 0.039319 8 0.0326704 7.67377 0.0393186C7.34754 0.0459667 5.5 -0.46772 3.5 2.03199C2 4 3.5 5 4.5 3.53199C4.5 3.53199 5.63924 1.58117 7.67377 1.73687C9.7083 1.89257 10.8262 3.53199 10.8262 6.03487C10.8262 8.53776 10.8544 7.52546 10.8262 7.52835C10.7341 7.53781 3 7.52835 2.5 7.53487H1.875C0.841667 7.53487 0 8.37505 0 9.40987V18.1599C0 19.1947 0.841667 20.0349 1.875 20.0349H13.125C14.1583 20.0349 15 19.1947 15 18.1599V9.40987C15.1768 8.17566 13.7136 7.33159 12.5 7.53487ZM8.33333 13.9699V15.8682C8.33333 16.3285 7.96083 16.7015 7.5 16.7015C7.03917 16.7015 6.66667 16.3285 6.66667 15.8682V13.9699C6.17083 13.6805 5.83333 13.1494 5.83333 12.5349C5.83333 11.6151 6.58083 10.8682 7.5 10.8682C8.41917 10.8682 9.16667 11.6151 9.16667 12.5349C9.16667 13.1494 8.82917 13.6805 8.33333 13.9699Z"
      fill="currentColor"
    />
  </svg>
);

export default PadlockOpenSvg;
